import Form from '@admin/components/form'
import SharesField from '../../sharesfield'
import * as options from '../variables'
import PropTypes from 'prop-types'
import React from 'react'

class Share extends React.Component {

  static propTypes = {
    config: PropTypes.object,
    onDone: PropTypes.func,
    onUpdate: PropTypes.func
  }

  state = {
    config: null
  }

  _handleChange = this._handleChange.bind(this)
  _handleDone = this._handleDone.bind(this)

  render() {
    if(!this.state.config) return null
    return <Form { ...this._getForm() } />
  }

  componentDidMount() {
    this.setState({
      config: {
        ...this._getDefault(),
        ...this.props.config
      }
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { config } = this.state
    if(!_.isEqual(config, prevState.config)) {
      this.props.onUpdate(config)
    }
  }

  _getForm() {
    const { config } = this.state
    return {
      title: 't(Social Share Block)',
      onCancel: this._handleDone,
      onChange: this._handleChange,
      cancelSvg: 'chevron_left',
      saveText: null,
      buttons: [
        { label: 't(Done)', color: 'blue', handler: this._handleDone }
      ],
      tabs: [
        {
          label: 't(Content)',
          sections: [
            {
              fields: [
                { name: 'networks', type: SharesField, defaultValue: config.networks }
              ]
            }
          ]
        }, {
          label: 't(Style)',
          sections: [
            {
              fields: [
                { label: 't(Background)', name: 'background_color', type: 'colorfield', defaultValue: config.background_color },
                this._getBorder('border', 'Border'),
                { label: 't(Padding)', name: 'padding', type: 'dropdown', options: options.paddings, defaultValue: config.padding }
              ]
            }, {
              label: 't(Button Style)',
              fields: [
                { label: 't(Background)', name: 'button_background_color', type: 'colorfield', defaultValue: config.button_background_color },
                { label: 't(Rounded Corners)', name: 'button_border_radius', type: 'range', min: 0, max: 20, defaultValue: config.button_border_radius }

              ]
            }, {
              label: 't(Text Style)',
              fields: [
                { label: 't(Font Family)', name: 'font_family', type: 'fontfamilyfield', defaultValue: config.font_family },
                { type: 'fields', fields: [
                  { label: 't(Font Size)', name: 'font_size', type: 'dropdown', options: options.font_sizes, defaultValue: config.font_size },
                  { label: 't(Color)', name: 'color', type: 'colorfield', defaultValue: config.color }
                ] },
                { type: 'fields', fields: [
                  { label: 't(Format)', name: 'format', type: 'formatfield', defaultValue: config.format },
                  { label: 't(Alignment)', name: 'text_align', type: 'alignmentfield', defaultValue: config.text_align }
                ] },
                { type: 'fields', fields: [
                  { label: 't(Line Height)', name: 'line_height', type: 'dropdown', options: options.line_heights, defaultValue: config.line_height },
                  { label: 't(Letter Spacing)', name: 'letter_spacing', type: 'dropdown', options: options.letter_spacing, defaultValue: config.letter_spacing }
                ] }
              ]
            }
          ]
        }, {
          label: 't(Settings)',
          sections: [
            {
              fields: [
                { label: 't(Align)', name: 'align', type: 'dropdown', options: ['left','center','right'], defaultValue: config.align },
                { label: 't(Icon Style)', name: 'icon_style', type: 'dropdown', options: ['solid','outline'], defaultValue: config.icon_style },
                { label: 't(Icon Color)', name: 'icon_color', type: 'dropdown', options: options.icon_colors, defaultValue: config.icon_color }
              ]
            }
          ]
        }
      ]
    }
  }

  _getDefault() {
    return {
      networks: [
        { service: 'facebook', text: 'Share' },
        { service: 'x', text: 'Tweet' },
        { service: 'forwardtofriend', text: 'Forward' }
      ],
      background_color: null,
      border_width: null,
      border_style: null,
      border_color: null,
      padding: 16,
      button_background_color: null,
      button_border_radius: 0,
      font_family: null,
      font_size: null,
      color: null,
      format: null,
      text_align: 'left',
      line_height: null,
      letter_spacing: null,
      align: 'center',
      icon_style: 'outline',
      icon_color: 'dark'
    }
  }

  _getBorder(type, label) {
    const { config } = this.state
    if(!config[`${type}_style`]) {
      return { label, name: `${type}_style`, type: 'dropdown', options: options.border_styles, placeholder: 'Style', defaultValue: config[`${type}_style`] }
    }
    return { label, type:'fields', fields: [
      { name: `${type}_style`, type: 'dropdown', options: options.border_styles, placeholder: 'Style', defaultValue: config[`${type}_style`] },
      { name: `${type}_width`, type: 'dropdown', options: options.border_widths, placeholder: 'Width', defaultValue: config[`${type}_width`] },
      { name: `${type}_color`, type: 'colorfield', defaultValue: config[`${type}_color`] }
    ] }
  }

  _handleChange(config) {
    this.setState({
      config: {
        ...this.state.config,
        ...config
      }
    })
  }

  _handleDone() {
    this.props.onDone()
  }

}

export default Share
